// @flow
import styled from '@emotion/styled';
import columnWidth from 'utils/columnWidth';
import type { BlokComponentPropsType } from 'components/types';
import ImageCards from './ImageCards';
import LargeImageCards from './LargeImageCards';
import TestimonialCards from './TestimonialCards';
import SimpleContentCards from './SimpleContentCards';
import * as componentKeys from '../../../componentKeys';

const componentMap = {
  [componentKeys.CARD_IMAGE]: ImageCards,
  [componentKeys.CARD_LARGE_IMAGE]: LargeImageCards,
  [componentKeys.CARD_SIMPLE_CONTENT]: SimpleContentCards,
  [componentKeys.TESTIMONIAL_BLOCK]: TestimonialCards
};

const ColumnSizer = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (min-width: 768px) {
    width: ${columnWidth(10)}%;
  }
`;

export default function Cards({ blok }: BlokComponentPropsType<any>) {
  const { cards } = blok;
  if (!cards.length) return null;
  const cardType = cards[0]?.component;
  if (!cardType) {
    console.warn('Invalid Cards Definition', { cards });
    return (
      <ColumnSizer>
        No Cards Definition for {(cardType || '').toString()}
      </ColumnSizer>
    );
  }
  const CardsComponent =
    componentMap[cardType] || componentMap[componentKeys.CARD_IMAGE];
  return (
    <ColumnSizer>
      <CardsComponent blok={blok} />
    </ColumnSizer>
  );
}
